/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * Class that describes a sort order sent from the UI
 */
export interface Sort { 
    ColumnName?: string;
    Direction?: Sort.DirectionEnum;
}
export namespace Sort {
    export type DirectionEnum = 'Asc' | 'Desc';
    export const DirectionEnum = {
        Asc: 'Asc' as DirectionEnum,
        Desc: 'Desc' as DirectionEnum
    };
}
